import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import axios from "axios";
import type { AxiosRequestConfig, AxiosError } from "axios";
import {store} from "../store/store";
import { setAuth } from "../../features/auth/slices/authSlice";

export const axiosInstance = axios.create({
    proxy: {
        protocol:"http",
        port: 8085,
        host: "",
    },
    timeout: 5000,
});

axiosInstance.interceptors.request.use(
    // config => {
    //     const user = store.getState().user;

    //     if (user && user.token) {
    //         const data = new URLSearchParams(config.data);
    //         const params = new URLSearchParams(config.params);
    //         const mergedParams = new URLSearchParams({
    //             ...Object.fromEntries(data),
    //             ...Object.fromEntries(params),
    //             userToken: user?.token
    //         });
    //         config.params = mergedParams;
    //     }
    //     return config;
    // },
    // error => {
    //     return Promise.reject(error);
    // }
);

axiosInstance.interceptors.response.use(
    // response => {
    //     return response;
    // },
    // error => {

    //     let messageCode = "";
    //     switch (error["status"]) {
    //         case 401:
    //             messageCode = "apiAuthError";
    //             // store.dispatch(setAuth({token: "", name: ""}));
    //             // if(!(error.config.url.includes("logout") || error.config.url.includes("/api/v1/auth/role") || error.config.url.includes("/api/v1/user/my"))) {
    //             //     window.dispatchEvent(new Event("sessionExpired"));
    //             // }
    //             break;
    //         case 404:
    //             messageCode = "apiNotFound";
    //             break;
    //         case 500:
    //             messageCode = "apiInternalError";
    //             break;
    //         default:
    //             messageCode = "apiError";
    //             break;
    //     }

    //     if (error.code === "ECONNABORTED" || error.code === "ERR_BAD_RESPONSE") {
    //         messageCode = "networkAborted";
    //     } else if (error.code === "ERR_NETWORK") {
    //         messageCode = "networkError";
    //     }

    //     if (messageCode === "apiAuthError" || messageCode === "networkAborted" || messageCode === "networkError") {
    //         store.dispatch(setAuth({token: "", name: ""}));
    //         if(!error.config.url.includes("/api/v1/login")) {
    //             // 현재 페이지가 로그인 페이지가 아닌 경우에만 Session Expired 이벤트 실행 (세션이 만료되었습니다. 메시지 표시)
    //             document.cookie = `remember_me=; path=/; max-age=0;`;
    //             document.cookie = `rdds_series=; path=/; max-age=0;`;
    //             window.dispatchEvent(new Event("sessionExpired"));
    //         }
    //     }

    //     return Promise.reject(error);
    // }
);


  
const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      method?: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
